import { UPDATE_BREADCRUMBS, GENERIC_ERROR } from "../actions/types";

const initialState = [];

export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case UPDATE_BREADCRUMBS:
      return [...state, payload];
    case GENERIC_ERROR:
      console.error(payload);
      return state;
    default:
      return state;
  }
}
